import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from './ActionButton';
import noop from '../../../util/noop';
import useConfirmAction from '../../../hooks/useConfirmAction';
import i18n from '../../../i18n/translate';

const DeleteActionButton = props => {
  const { action = noop, actionType, confirmChildren, confirmTitle,
    deleteMember, row = {} } = props;

  const { action: confirmAction, confirmationModal } = useConfirmAction({
    action: deleteMember ?
      function() { deleteMember(row) } :
      action,
    children: confirmChildren,
    disabled: actionType !== 'confirm',
    title: confirmTitle
  });

  return (
    <>
      <ActionButton
        icon="delete"
        title={i18n.t("delete")}
        tooltip={i18n.t("Delete")}
        {...props}
        actionType="callToAction"
        action={confirmAction}
      />
      {confirmationModal}
    </>
  );
};

DeleteActionButton.propTypes = {
  action: PropTypes.func,
  actionType: PropTypes.oneOf(['confirm', 'link', 'externalLink', 'callToAction']),
  confirmChildren: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  confirmTitle: PropTypes.string,
  deleteMember: PropTypes.func,
  row: PropTypes.object.isRequired
};

export default DeleteActionButton;
